import React from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import "./EatsAdminCreatePage.css";

const EatsAdminPageHeader = ({
  title,
  subtitle,
  beforeTitle = null,
  homeTo = "/eats/admin",
  onHome,
  backTo,
  onBack,
  actions = null,
}) => {
  const navigate = useNavigate();
  const goBack = () => (onBack ? onBack() : backTo ? navigate(backTo) : navigate(-1));

  return (
    <div className="eats-admin-create-header">
      <div className="eats-admin-create-header__main">
        <button
          type="button"
          className="eats-admin-create-header__back-icon"
          onClick={goBack}
          aria-label="Back"
          title="Back"
        >
          <FiArrowLeft aria-hidden="true" />
        </button>
        <div className="eats-admin-create-header__text">
          {beforeTitle}
          {title ? <h2 className="eats-admin-create-title">{title}</h2> : null}
          {subtitle ? <p className="eats-admin-create-subtitle">{subtitle}</p> : null}
        </div>
      </div>
      <div className="eats-admin-create-header-actions">
        {actions}
        <button
          type="button"
          className="eats-admin-header-btn eats-admin-header-btn--home"
          onClick={() => (onHome ? onHome() : navigate(homeTo))}
        >
          Home
        </button>
        <button
          type="button"
          className="eats-admin-header-btn eats-admin-header-btn--back"
          onClick={goBack}
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default EatsAdminPageHeader;
